import { Text, VStack } from "@chakra-ui/react";
import { PageContainer } from "../../components";
import { CardSummaryTabs } from "./CardSummaryTabs";
import { useDocumentTitle } from "usehooks-ts";

export function DashboardPage() {
  useDocumentTitle("Dashboard | Cardoly");

  return (
    <PageContainer>
      <VStack alignItems={"stretch"} spacing={"md"}>
        <Text variant="h3" color="gray.700">
          Cardolies
        </Text>
        <CardSummaryTabs />
      </VStack>
    </PageContainer>
  );
}
